export default __webpack_public_path__ + "static/media/sticker-R.a140d023.png";